import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

import {
	API_URL,
	scroll,
	getValFromLS,
	isAllowedHotel,
	isAllowedOffSiteHotel,
} from "../../helpers";

import Hdg from "../../components/Hdg";
import Alert from "../../components/Alert";
import Notice from "../../components/Notice";

import Stripe from "./Stripe";
import HomeTop from "./HomeTop";
import HomeBottom from "./HomeBottom";
import OffSiteHotels from "./OffSiteHotels";

import Nav from "../Nav";

const chkName = (wordToCompare) => (element, index, array) => {
	const str = wordToCompare.toLowerCase();
	return element.occupant.toLowerCase().search(str) !== -1 ? true : false;
};

const chkNight = (night) => (element, index, array) => {
	return element[night] ? true : false;
};

const chkStatus = (status) => (element, index, array) => {
	return element.status === parseInt(status, 10) ? true : false;
};

const chkHotel = (wordToCompare) => (element, index, array) => {
	const str = wordToCompare.toLowerCase();
	return element.hotel.toLowerCase().search(str) !== -1 ? true : false;
};

const Hotel = () => {
	const [user, setUser] = useState({});
	const [details, setDetails] = useState({});
	const [sortedApprovedPending, setSortedApprovedPending] = useState([]);
	const [sortedRejected, setSortedRejected] = useState([]);
	const [notice, setNotice] = useState({});
	const [alert, setAlert] = useState({
		type: "working",
		text: "",
	});

	const location = useLocation();

	useEffect(() => {
		if (location.state && location.state.message) {
			setNotice({
				type: location.state.message.type,
				text: location.state.message.text,
			});
		}
	}, [location]);

	useEffect(() => {
		const init = async () => {
			const auth = getValFromLS("dash", true)
				? JSON.parse(getValFromLS("dash", true))
				: {};
			const url = new URL(`${API_URL}/dashboardHotelInit`);
			const params = {
				id: auth.id ? auth.id : "",
			};
			url.search = new URLSearchParams(params);

			try {
				const response = await fetch(url, {
					method: "GET",
					cache: "no-store",
				});
				const json = await response.json();
				if (json && json.resp === 1) {
					setUser({ ...JSON.parse(getValFromLS("dash", true)) });
					if (json.totalSpots === 0) {
						setNotice({
							type: "notice",
							text: "Your sponsorship package does not include any guaranteed JW Marriott room nights.",
						});
					} else if (json.allFilled) {
						setNotice({
							type: "notice",
							text: "All your available JW Marriott room nights have been filled, thank you.",
						});
					}

					setDetails({
						...json,
					});

					setAlert({});
					scroll();
				} else {
					setAlert({
						type: json.resp === 2 ? "notice" : "error",
						text: json.text,
					});
				}
			} catch (error) {
				setAlert({
					type: "error",
					text: "An error has occurred.",
				});
			}
		};

		init();
	}, []);

	useEffect(() => {
		if (details.approvedPending) {
			setSortedApprovedPending([...details.approvedPending]);
		}
		if (details.rejected) {
			setSortedRejected([...details.rejected]);
		}
	}, [details.approvedPending, details.rejected]);

	const handleAdded = (cc) => {
		setDetails((details) => ({ ...details, stripe: cc }));
	};

	const handleChange = (name, value) => {
		let filter = null;

		if (name === "name" && value.length > 1) {
			filter = chkName(value);
		} else if (name === "night" && value.length) {
			filter = chkNight(value);
		} else if (name === "status" && value.length) {
			filter = chkStatus(value);
		} else if (name === "hotel" && value.length) {
			filter = chkHotel(value);
		}

		if (filter) {
			const newApprovedPendingArray1 = details.approvedPending.filter(filter);
			setSortedApprovedPending([...newApprovedPendingArray1]);

			const newRejectedArray2 = details.rejected.filter(filter);
			setSortedRejected([...newRejectedArray2]);
		} else {
			setSortedApprovedPending([...details.approvedPending]);
			setSortedRejected([...details.rejected]);
		}
	};

	return (
		<>
			{alert.type ? (
				<Alert data={alert} />
			) : (
				<>
					<div
						id="left-column"
						style={{ marginBottom: "0", paddingBottom: "25px" }}
					>
						<Hdg section="Manage Hotel Occupants" />

						{!details.jwStatus ? (
							<OffSiteHotels />
						) : isAllowedHotel(details.levelId) ||
						  details.registrationId === 25425 ||
						  details.registrationId === 26059 ? (
							<>
								{!details.stripe ? (
									<Stripe added={handleAdded} />
								) : (
									<>
										{notice.type && <Notice data={notice} />}
										<HomeTop details={details} />
									</>
								)}
							</>
						) : isAllowedOffSiteHotel(details.levelId) ? (
							<>
								{/*<Notice
									data={{
										type: "notice",
										text: "Links to make your hotel reservations will be available at a later date. Please monitor your email for updates.",
									}}
								/>*/}

								<OffSiteHotels />
							</>
						) : (
							<Notice
								data={{
									type: "notice",
									text: "Links to make your hotel reservations will be available at a later date. Please monitor your email for updates.",
								}}
							/>
						)}
					</div>

					<div id="right-column">
						<Nav on={9} user={user} />
					</div>

					<div className="spacer" style={{ height: "0" }}></div>

					{(isAllowedHotel(details.levelId) ||
						details.registrationId === 25425 ||
						details.registrationId === 26059) &&
						details.stripe && (
							<div
								id="full-column"
								style={{ marginTop: "0", paddingTop: "0", minHeight: "100%" }}
							>
								<HomeBottom
									approvedPending={sortedApprovedPending}
									rejected={sortedRejected}
									change={handleChange}
								/>
							</div>
						)}
				</>
			)}
		</>
	);
};

export default Hotel;
